import { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import { getInterviewBookingContact } from '../../utils/contactHelpers';

interface NavItem {
  label: string;
  anchor: string;
  section: string;
}

interface StickyAnchorNavProps {
  onMobileMenuToggle?: () => void;
  isMobileMenuOpen?: boolean;
}

const StickyAnchorNav = ({ onMobileMenuToggle, isMobileMenuOpen = false }: StickyAnchorNavProps) => {
  const [activeSection, setActiveSection] = useState<string>('hero');
  const [scrollProgress, setScrollProgress] = useState<number>(0);

  const navItems: NavItem[] = [
    { label: 'Главная', anchor: '#hero', section: 'hero' },
    { label: 'Как работает', anchor: '#how-it-works', section: 'how-it-works' },
    { label: 'Результаты', anchor: '#results', section: 'results' },
    { label: 'Стоимость', anchor: '#pricing', section: 'pricing' },
    { label: 'Вопросы', anchor: '#faq', section: 'faq' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (scrollTop / docHeight) * 100;
      setScrollProgress(progress);

      const sections = navItems.map(item => document.querySelector(item.anchor));
      const scrollPosition = scrollTop + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section && section instanceof HTMLElement) {
          if (scrollPosition >= section.offsetTop) {
            setActiveSection(navItems[i].section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (anchor: string) => {
    const element = document.querySelector(anchor);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleInterviewClick = getInterviewBookingContact();

  const handleCTAClick = () => {
    window.open('https://t.me/Aidating_love7_bot?start=012_res', '_blank');
  };

  return (
    <header className="sticky top-0 bg-background border-b border-border z-header">
      <div className="relative">
        <div 
          className="absolute bottom-0 left-0 h-0.5 bg-primary transition-all duration-300"
          style={{ width: `${scrollProgress}%` }}
        />
      </div>
      
      <div className="max-w-content mx-auto">
        <div className="flex items-center justify-between h-header-desktop md:h-header-desktop sm:h-header-mobile">
          <div className="flex items-center">
            <a 
              href="#hero" 
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#hero');
              }}
              className="flex items-center gap-2 transition-opacity duration-200 hover:opacity-80"
            >
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Heart" size={24} color="white" />
              </div>
              <span className="text-xl font-bold text-foreground hidden sm:block">AI Dating</span>
            </a>
          </div>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.section}
                href={item.anchor}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.anchor);
                }}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                  activeSection === item.section
                    ? 'text-primary bg-primary/10' :'text-secondary hover:text-foreground hover:bg-muted'
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="https://t.me/Aidating_love7_bot"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2 px-4 py-2 bg-primary text-white rounded-md text-sm font-medium hover:bg-primary/90 transition-colors"
            >
              пройти тест
            </a>
          </nav>

          <button
            onClick={onMobileMenuToggle}
            className="md:hidden p-2 rounded-md hover:bg-muted transition-colors duration-200"
            aria-label="Toggle mobile menu"
          >
            <Icon 
              name={isMobileMenuOpen ? "X" : "Menu"} 
              size={24} 
              color="var(--color-foreground)" 
            />
          </button>
        </div>
      </div>
    </header>
  );
};

export default StickyAnchorNav;